//dark mode colors
export const darkBlue = "#152237";
export const gold = "#d3a255";
export const sage = "#68a09b";
export const lightSage = "#a4bfd4";
export const medSage = "#2b3b54";

// new light mode colors
export const medMauve = "#e5ddde";
export const lightMauve = "#916a6f";
export const cream = "#f7f5f5";
export const darkMauve = "#654a4e";
export const forestGreen = "#4A6561";
export const lightForestGreen = "#d3dedd";

export const gray = "rgba(0, 0, 0, 0.6)";
export const lightGray = "#cfced0";
export const white = "white";
export const black = "#010101";
// old light mode colors
export const medGreen = "#338776";
export const darkGreen = "#654a4e";
export const darkPink = "#4A6561";
export const medPink = "#ff70ba";
export const lightPink = "#d3dedd";

// fonts
export const headingFont = "Young Serif";
export const bodyFont = "Lexend";
